import React from 'react'
import './IconLoadingNumber.css'

import { connect } from 'react-redux'
import { getPorcentajeLoaded } from '../../modules/reducer'

//https://codepen.io/JMChristensen/pen/Ablch
//https://stackoverflow.com/questions/14218607/javascript-loading-progress-of-an-image

const IconLoadingNumber = ({ porcentaje }) => {
  const r = 90
  const c = Math.PI * (r * 2)

  let pct
  if (porcentaje < 0) {
    pct = 0
  }
  if (porcentaje > 100) {
    pct = 100
  }

  pct = ((100 - porcentaje) / 100) * c

  return (
    <div id="cont" data-pct={porcentaje}>
      <svg
        id="svg"
        width="200"
        height="200"
        viewPort="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          r="90"
          cx="100"
          cy="100"
          fill="transparent"
          stroke-dasharray="565.48"
          stroke-dashoffset="0"
        />
        <circle
          id="bar"
          r="90"
          cx="100"
          cy="100"
          fill="transparent"
          stroke-dasharray="565.48"
          stroke-dashoffset={pct}
        />
      </svg>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    porcentaje: getPorcentajeLoaded(reducer)
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconLoadingNumber)
